baseApp.service('MaintenanceWindowService', function(){
    return {
        getConsts: function (){
            return {
                WEEKS: [0,1],
                DAYS: [1,2,3,4,5,6,7],
                TIMESLOTS: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23],
                DEFUALT_TIME: 0,
                DEFUALT_DAY: 7,
                DEFUALT_WEEK: 0
            }
        },
        getDefaultWindow: function () {
            return{
                time: new moment(0, 'HH:mm').format("HH:mm"),
                day: 7,
                week: 0
            }
        }
    }
});
